
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website, WebsiteComposite } from '@/services/Website/interfaces';

export interface DbManageDatabase {
  id: number;
  name: string;
  size?: number;
}

export interface DbManageData {
  databases?: DbManageDatabase[];
  dbError?: string;
}

@Component
export default class DbManagePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  @Prop({ type: Object, default: () => ({}) })
  public panelData!: DbManageData;

  public confirmDeleteId: number | null = null;

  public confirmInput: string = '';

  public createFormValid: boolean = false;

  public createName: string = '';

  public createPassword: string = '';

  public createPasswordConf: string = '';

  public get website(): Website {
    return this.composite.website;
  }

  public get databases(): DbManageDatabase[] {
    return (this.panelData && this.panelData.databases) || [];
  }

  public get confirmValid(): boolean {
    return this.confirmDeleteId !== null
      && this.confirmInput.trim().toLowerCase() === this.website.domain.toLowerCase();
  }

  public get canCreate(): boolean {
    return this.createFormValid
      && !!this.createName
      && !!this.createPassword
      && this.createPassword === this.createPasswordConf;
  }

  public requiredRule(value: string): boolean | string {
    return !!value || 'Required';
  }

  public passwordConfRule(value: string): boolean | string {
    return value === this.createPassword || 'Passwords do not match';
  }

  public startDelete(databaseId: number): void {
    this.confirmDeleteId = databaseId;
    this.confirmInput = '';
  }

  public cancelDelete(): void {
    this.confirmDeleteId = null;
    this.confirmInput = '';
  }

  public confirmDelete(): void {
    if (!this.confirmValid || this.confirmDeleteId === null) {
      return;
    }
    const databaseId = this.confirmDeleteId;
    this.cancelDelete();
    this.emitSubmit('delete', { databaseId });
  }

  public submitCreate(): void {
    if (!this.canCreate) {
      return;
    }
    this.emitSubmit('create', {
      name: this.createName,
      password: this.createPassword,
      passwordConf: this.createPasswordConf,
    });
    this.createName = '';
    this.createPassword = '';
    this.createPasswordConf = '';
  }

  public emitSubmit(operation: string, payload: Record<string, unknown> = {}): void {
    this.$emit('submit', { operation, ...payload });
  }
}
